import React from "react";
const FilterIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.39H0.89V0.5V2.45536V2.50026L0.921427 2.53234L7.60839 9.35741V16.5V16.61H7.71839H12.1973H12.3073V16.5V9.35741L18.9943 2.53234L19.0257 2.50026V2.45536V0.5V0.39H18.9157H1ZM8.94812 8.83036V8.78545L8.91669 8.75338L2.22973 1.92831V1.75286H17.686V1.92831L10.999 8.75338L10.9676 8.78545V8.83036V15.2471H8.94812V8.83036ZM17.277 9.30333L17.2772 9.1931H17.167H16.0412H15.9309L15.9312 9.30333L15.9371 12.0907L13.2083 12.0847L13.0981 12.0844V12.1947V13.3437V13.4539L13.2083 13.4537L15.9371 13.4476L15.9312 16.235L15.9309 16.3453H16.0412H17.167H17.2772L17.277 16.235L17.271 13.4476L19.9998 13.4537L20.11 13.4539V13.3437V12.1947V12.0844L19.9998 12.0847L17.271 12.0907L17.277 9.30333Z"
        fill="#282828"
        stroke="black"
        strokeWidth="0.22"
      />
    </svg>
  );
};

export default FilterIcon;
